import { useState } from "react";

const AskDelete = () => {
  const [username, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("idle"); // idle, loading, success, error
  const [errorMessage, setErrorMessage] = useState("");

  const goHome = () => {
    window.history.pushState(null, "", "/");
    window.location.reload();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMessage("");

    try {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_URL || "https://getdispo.com/api"
        }/deletion-request`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: username.trim(),
            message: message.trim() || undefined,
          }),
        }
      );

      const data = await response.json();

      if (response.ok || response.status === 202) {
        setStatus("success");
        setUsername("");
        setMessage("");
      } else {
        setStatus("error");
        setErrorMessage(
          data.message ||
            data.error ||
            "Une erreur est survenue"
        );
      }
    } catch (error) {
      setStatus("error");
      setErrorMessage(
        "Impossible de contacter le serveur. Veuillez réessayer plus tard."
      );
    }
  };

  return (
    <div className="legal-container">
      <div className="legal-content">
        <button onClick={goHome} className="back-button">
          ← Retour à l'accueil
        </button>
        <h1>Demande de suppression de compte</h1>
        <p className="description">
          Vous souhaitez supprimer votre compte Dispo ? Remplissez le formulaire
          ci-dessous et nous traiterons votre demande dans les plus brefs
          délais.
        </p>

        {status === "success" ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Demande envoyée !</h2>
            <p>
              Votre demande de suppression de compte a bien été enregistrée.
              Nous la traiterons dans les plus brefs délais.
            </p>
            <button onClick={goHome} className="submit-button">
              Retour à l'accueil
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="delete-form">
            <div className="form-group">
              <label htmlFor="username">Nom d'utilisateur *</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Entrez votre nom d'utilisateur"
                required
                maxLength={50}
                disabled={status === "loading"}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message (optionnel)</label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Raison de la suppression ou informations supplémentaires..."
                rows={4}
                maxLength={1000}
                disabled={status === "loading"}
              />
            </div>

            {status === "error" && (
              <div className="error-message">{errorMessage}</div>
            )}

            <button
              type="submit"
              className="submit-button"
              disabled={status === "loading" || !username.trim()}
            >
              {status === "loading"
                ? "Envoi en cours..."
                : "Envoyer la demande"}
            </button>
          </form>
        )}

        <section className="info-section">
          <h2>Informations importantes</h2>
          <ul>
            <li>La suppression de votre compte est irréversible</li>
            <li>Toutes vos données personnelles seront supprimées</li>
            <li>Vos disponibilités et messages seront effacés</li>
            <li>Le traitement peut prendre jusqu'à 30 jours</li>
          </ul>
        </section>
      </div>

      <style jsx>{`
        .legal-container {
          min-height: 100vh;
          background: linear-gradient(
            135deg,
            #061220 0%,
            #0a1929 50%,
            #102a43 100%
          );
          padding: 40px 20px;
          color: #f0f4f8;
          font-family: "Poppins", system-ui, sans-serif;
        }

        .legal-content {
          max-width: 600px;
          margin: 0 auto;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 40px;
          border: 1px solid rgba(56, 189, 248, 0.15);
        }

        .back-button {
          background: rgba(56, 189, 248, 0.1);
          border: 1px solid rgba(56, 189, 248, 0.3);
          color: #38bdf8;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          margin-bottom: 20px;
          transition: all 0.3s ease;
          font-family: "Poppins", system-ui, sans-serif;
        }

        .back-button:hover {
          background: rgba(56, 189, 248, 0.2);
          transform: translateY(-2px);
        }

        h1 {
          font-size: 2rem;
          margin-bottom: 10px;
          text-align: center;
          font-weight: 600;
          background: linear-gradient(135deg, #38bdf8 0%, #7dd3fc 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .description {
          text-align: center;
          opacity: 0.8;
          margin-bottom: 30px;
          color: #9fb3c8;
          line-height: 1.6;
        }

        .delete-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        label {
          font-size: 14px;
          font-weight: 500;
          color: #7dd3fc;
        }

        input,
        textarea {
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(56, 189, 248, 0.2);
          border-radius: 10px;
          padding: 14px 16px;
          font-size: 16px;
          color: #f0f4f8;
          font-family: "Poppins", system-ui, sans-serif;
          transition: all 0.3s ease;
        }

        input:focus,
        textarea:focus {
          outline: none;
          border-color: #38bdf8;
          background: rgba(255, 255, 255, 0.08);
        }

        input::placeholder,
        textarea::placeholder {
          color: #627d98;
        }

        input:disabled,
        textarea:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        textarea {
          resize: vertical;
          min-height: 100px;
        }

        .submit-button {
          background: linear-gradient(135deg, #38bdf8 0%, #0ea5e9 100%);
          border: none;
          border-radius: 10px;
          padding: 16px 24px;
          font-size: 16px;
          font-weight: 600;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: "Poppins", system-ui, sans-serif;
          margin-top: 10px;
        }

        .submit-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(56, 189, 248, 0.3);
        }

        .submit-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .error-message {
          background: rgba(239, 68, 68, 0.15);
          border: 1px solid rgba(239, 68, 68, 0.3);
          border-radius: 10px;
          padding: 14px 16px;
          color: #fca5a5;
          font-size: 14px;
        }

        .success-message {
          text-align: center;
          padding: 30px 0;
        }

        .success-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 40px;
          color: white;
          margin: 0 auto 20px;
        }

        .success-message h2 {
          font-size: 1.5rem;
          margin-bottom: 10px;
          color: #10b981;
        }

        .success-message p {
          color: #9fb3c8;
          margin-bottom: 30px;
          line-height: 1.6;
        }

        .info-section {
          margin-top: 40px;
          padding-top: 30px;
          border-top: 1px solid rgba(56, 189, 248, 0.15);
        }

        .info-section h2 {
          font-size: 1.2rem;
          margin-bottom: 15px;
          color: #38bdf8;
        }

        .info-section ul {
          margin: 0;
          padding-left: 20px;
        }

        .info-section li {
          margin-bottom: 8px;
          line-height: 1.5;
          color: #bcccdc;
          font-size: 14px;
        }

        @media (max-width: 768px) {
          .legal-content {
            padding: 20px;
            margin: 0 10px;
          }

          h1 {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </div>
  );
};

export default AskDelete;
